$(function () {
  $('.alert').removeClass('hidden-alert');

  setTimeout(function () {
    $('.alert').addClass('hidden-alert');
  }, 6000);
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/flash_messages.js